import React from 'react'
import TabLinkUI from "../../../../widgets/output/TabLinkUI"
import './MasterTemplateNav.css'

const MasterLoanAgrNavUI = ({ context, page }) =>
  <div className='g_flex_h g_flex_wrap g_flex_left g_p_left_100 master-template-nav-secondary g_m_top_25'>
    <TabLinkUI label='General Terms' to='/su/master/loanAgreement/general' active={page === 'general'} />
    <TabLinkUI label='Loan-Specific Terms' to='/su/master/loanAgreement/nbfc' active={page === 'loanSpecific'} />
    <TabLinkUI label='Pledge/NDU Terms' to='/su/master/loanAgreement/pledge' active={page === 'guarantee'} />
    <TabLinkUI label='Escrow/Special Terms' to='/su/master/loanAgreement/escrow' active={page === 'escrow'} />
  </div>

export default MasterLoanAgrNavUI
